import React from "react";
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
import { Borderless, Logo } from "./../../Public/assets";
import {
  text1,
  text2,
  text3,
  text4,
  text5,
  text6,
  text10,
  text7
  // text8,
} from "./../../Public/assets/data";
import { useTheme } from "../../Context/Theme";

const WebsiteFooter = () => {
  const { themeData } = useTheme();

  return (
    <footer className="bg-darkblue text-white pt-12 ">
      {/* Main Footer Content */}
      <div className="container mx-auto px-6 xl:px-[134px]">
        <div className="flex flex-col lg:flex-row justify-between gap-8">
          {/* Logo and Description */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <a
                href="https://borderless.world/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={Logo}
                  alt=""
                  className=" !w-[75px] md:!w-[135px] !min-w-[100px] !min-h-[30px]"
                />
              </a>
            </div>
            <p className=" font-geomanistRegular font-sm text-[14px] leading-[20px] text-[#fff] lg:max-w-sm">
              Experience the power of borderless money
            </p>
          </div>
          {/* <div className="flex  flex-col sm:flex-row  gap-16"> */}

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-[16px] font-[400]  font-geomanistBold">
              Contact us
            </h3>
            <ul className="space-y-[14px] text-[14px] leading-[14px]">
              <li className="">
                <a href={`mailto:${themeData?.data?.senderEmail}`}>
                  {themeData?.data?.senderEmail}
                </a>
              </li>
              <li className="">
                <a href={`tel:${themeData?.data?.supportPhone}`}>
                  {themeData?.data?.supportPhone}{" "}
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media Links */}
          <div className="space-y-4">
            <h3 className="text-[16px] font-[400]  font-geomanistBold">
              Follow us on
            </h3>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/worldisborderless"
                target="_blank"
                rel="noreferrer"
                className="text-white hover:text-gray-400"
              >
                <Facebook size={24} fill="white" strokeWidth={0} />
              </a>
              <a
                href="https://x.com/get_borderless"
                target="_blank"
                rel="noreferrer"
                className="text-white hover:text-gray-400"
              >
                <Twitter size={24} fill="white" strokeWidth={0} />
              </a>
              <a
                href="https://www.instagram.com/get_borderless/"
                target="_blank"
                rel="noreferrer"
                className="text-white hover:text-gray-400"
              >
                <Instagram size={24} />
              </a>
              <a
                href="https://www.linkedin.com/company/borderless-world/"
                target="_blank"
                rel="noreferrer"
                className="text-white hover:text-gray-400"
              >
                <Linkedin size={24} fill="white" strokeWidth={0} />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}

      {/* Copyright Bar */}
      <div className="border-t  border-hrfooter mt-12 pt-8">
        <div className="container mx-auto ">
          <p className="text-white text-sm text-center">
            By using these payment services, you agree to Airwallex's T&Cs 
            <a
              href="https://www.airwallex.com/sg/terms/stockal"
              target="_blank"
              rel="noreferrer"
              className="text-white hover:text-gray-400 underline cursor-pointer"
            >
              here.
            </a>
          </p>
        </div>
        {/* <div className="container mx-auto px-4"> */}
        {/* <p className="text-[#A4ABB7] text-sm text-center">
            BORDERLESS SOFTTECH PVT LTD, A SUBSIDIARY OF BORDERLESS INVESTING
            INC. ALL RIGHTS RESERVED. <span className="mx-2">| </span> All
            Rights Reserved <span className="mx-2">| </span>
            Copyright © 2010 — 2025
          </p> */}
        {/* </div> */}
      </div>
      <hr className=" border-hrfooter  mt-8 " />
      <img
        src={Borderless}
        alt="borderless"
        className="px-6  xl:px-[66px] max-w-[90%] mx-auto  my-[36px] lg:my-[50px] flex justify-center items-center w-full"
      />

      <hr className=" px-6 xl:px-[66px] border-hrfooter" />
      <div className="my-7 px-[18px] md:px-18 xxl:px-[134px] flex flex-col items-center justify-center font-AktivGrotesk font-normal text-base leading-[27.52px] text-white">
        ©Borderless 2025, All Rights Reserved.
      </div>
      <hr className="  border-hrfooter mt-8 pt-8" />
      <div className="mx-auto max-w-[95%] px-6 xl:px-[96px] mt-7 mb-12 md:mx-18 xxl:mx-[134px] text-white font-AktivGrotesk font-normal text-sm leading-[24.08px]">
        <p>{text1}</p> <br />
        <p className="flex ">
          <div className="pr-4  border-r">
            <a
              href="https://help.stockal.com/portal/en/kb/articles/investing"
              target="_blank"
              rel="noreferrer"
            >
              <span className="text-white hover:text-blue-400 "> {text2}</span>
            </a>
          </div>
          <div className="px-4  border-r">
            <a
              href="https://help.stockal.com/portal/en/kb/articles/savings-4-11-2025"
              target="_blank"
              rel="noreferrer"
            >
              <span className="text-white hover:text-blue-400 "> {text3}</span>
            </a>
          </div>
          <div className="px-4  ">
            <a
              href="https://help.stockal.com/portal/en/kb/articles/payments-4-11-2025"
              target="_blank"
              rel="noreferrer"
            >
              <span className="text-white hover:text-blue-400 "> {text4}</span>
            </a>
          </div>
        </p>
        <br />
        <p>
          {text6}{" "}
          <span>
          <a
            href="https://www.sipc.org"
            target="_blank"
            rel="noreferrer" >
              <span className="text-blue-600 underline hover:text-blue-800 "> {text7}{" "}</span>
          </a>
          </span>
          {/* </Link>{" "} */}
          {/* {text8} */}
        </p>
        <br />
        {/* <p>{text9}</p> <br /> */}
        <p>{text10}</p> <br />
        <p>{text5}</p> <br />
        {/* <p>
          {text11} <span className="font-bold">{text12} </span>
        </p> */}
      </div>
    </footer>
  );
};

export default WebsiteFooter;
